type EventCallback = (data?: any) => void;

class EventBus {
  private listeners = new Map<string, Map<EventCallback, EventListener>>();

  on(event: string, callback: EventCallback) {
    const listener = (e: Event) => callback((e as CustomEvent).detail);
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Map());
    }
    this.listeners.get(event)!.set(callback, listener);
    document.addEventListener(event, listener);
  }

  dispatch(event: string, data?: any) {
    document.dispatchEvent(new CustomEvent(event, { detail: data }));
  }

  remove(event: string, callback: EventCallback) {
    const eventListeners = this.listeners.get(event);
    if (eventListeners?.has(callback)) {
      const listener = eventListeners.get(callback)!;
      document.removeEventListener(event, listener);
      eventListeners.delete(callback);
    }
  }
}

export default new EventBus();
